"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.assign");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _recursiveChildrenMap = _interopRequireDefault(require("../utils/recursiveChildrenMap"));

var _GrvPortal = _interopRequireDefault(require("../GrvPortal"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var propTypes = {
  actionText: _propTypes["default"].string,
  active: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  message: _propTypes["default"].node,
  // instanceOf Element, use object for server side rendering
  mountNode: _propTypes["default"].object,
  // eslint-disable-line react/forbid-prop-types
  onAction: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  portalClassName: _propTypes["default"].string,
  portalId: _propTypes["default"].string,
  portalStyle: _propTypes["default"].objectOf(_propTypes["default"].string),
  type: _propTypes["default"].string
};
var defaultProps = {
  active: true,
  message: '',
  onAction: function onAction() {},
  onClose: function onClose() {},
  type: 'informational'
};

var Alert = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Alert, _Component);

  function Alert() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.handleAction = function (event) {
      var onAction = _this.props.onAction;
      event.preventDefault();
      onAction(event);
    };

    _this.buildActionText = function () {
      var _this$props = _this.props,
          actionText = _this$props.actionText,
          type = _this$props.type;

      if (actionText) {
        if (type === 'global') {
          return /*#__PURE__*/_react["default"].createElement("a", {
            className: "grv-alert__link",
            href: "",
            onClick: _this.handleAction
          }, actionText);
        }

        return /*#__PURE__*/_react["default"].createElement("button", {
          className: "grv-alert__close grv-button--text grv-button--compact",
          onClick: _this.handleAction,
          type: "button"
        }, actionText);
      }

      return null;
    };

    return _this;
  }

  var _proto = Alert.prototype;

  _proto.render = function render() {
    var _this$props2 = this.props,
        message = _this$props2.message,
        type = _this$props2.type,
        onClose = _this$props2.onClose,
        active = _this$props2.active,
        className = _this$props2.className,
        portalClassName = _this$props2.portalClassName,
        portalStyle = _this$props2.portalStyle,
        portalId = _this$props2.portalId,
        mountNode = _this$props2.mountNode,
        onAction = _this$props2.onAction,
        actionText = _this$props2.actionText,
        otherProps = _objectWithoutPropertiesLoose(_this$props2, ["message", "type", "onClose", "active", "className", "portalClassName", "portalStyle", "portalId", "mountNode", "onAction", "actionText"]);

    if (!active) {
      return null;
    }

    var classes = (0, _classnames["default"])('grv-alert', "grv-alert--" + type, className);
    var sharedProps = Object.assign({}, otherProps, {
      className: classes,
      role: 'alert'
    });
    var formattedMessage = (0, _recursiveChildrenMap["default"])(message, function (child) {
      if (typeof child === 'object' && 'type' in child && child.type === 'a') {
        var _ref = child,
            childClassName = _ref.props.className;
        return /*#__PURE__*/_react["default"].cloneElement(child, {
          className: (0, _classnames["default"])('grv-text__link', childClassName)
        });
      }

      return child;
    });

    if (type === 'global') {
      return /*#__PURE__*/_react["default"].createElement(_GrvPortal["default"], {
        prepend: true,
        className: portalClassName,
        id: portalId,
        mountNode: mountNode,
        style: portalStyle
      }, /*#__PURE__*/_react["default"].createElement("div", sharedProps, /*#__PURE__*/_react["default"].createElement("p", {
        className: "grv-alert__message"
      }, formattedMessage, " ", this.buildActionText()), /*#__PURE__*/_react["default"].createElement("button", {
        className: "grv-alert__close",
        onClick: onClose,
        type: "button"
      }, /*#__PURE__*/_react["default"].createElement("span", null, "Close"))));
    }

    return /*#__PURE__*/_react["default"].createElement("div", sharedProps, /*#__PURE__*/_react["default"].createElement("p", {
      className: "grv-alert__message"
    }, formattedMessage), this.buildActionText());
  };

  return Alert;
}(_react.Component);

Alert.propTypes = propTypes;
Alert.defaultProps = defaultProps;
var _default = Alert;
exports["default"] = _default;